import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';

const StyledToastContainer = styled(ToastContainer)`
  top: 96px;

  .Toastify__toast  {
    min-height: 52px;
  }

  .Toastify__toast-body  {
    ${({ theme }) => theme.typograph.paragraphRegular};
    color: ${({ theme }) => theme.colors.backgroundColorWhite};  
  }

  .Toastify__close-button {
    align-self: auto;
    margin-left: 16px;

    svg path {
      fill: ${({ theme }) => theme.colors.backgroundColorWhite};
    }
  }

  .Toastify__toast--error {
    background-color: ${({ theme }) => theme.colors.statusColorError};
  }

  .Toastify__toast--warning {
    background-color: ${({ theme }) => theme.colors.statusColorWarning};
  }

  .Toastify__toast--success {
    background-color: ${({ theme }) => theme.colors.statusColorSuccess};
  }
`;

export {
  StyledToastContainer,
};
